import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { SIGNUP_PLATFORM_PATH } from '../../install/shared/navigation/constants';
import { ENV } from '../../environment';
import { from, Observable } from 'rxjs';
import { LaunchDarklyService } from '../../shared/services/launchdarkly.service';
import { RedirectService } from '../../shared/services/redirect.service';
import { concatMap, filter, map } from 'rxjs/operators';
import { AuthService } from '@yotpo-ui/core';


@Injectable()
export class RegisterGuard implements CanActivate {

  constructor(private authService: AuthService,
    private router: Router,
    private redirectService: RedirectService,
    private launchDarklyService: LaunchDarklyService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return from(this.launchDarklyService.serviceReady).pipe(
      map((clientInitiated) => {
        if (clientInitiated) {
          const navigateToNewSignup = this.launchDarklyService.getFlagStatus('yo-new-signup-navigation');

          if (navigateToNewSignup) {
            const url = ENV.YotpoAccountsSignupUrl + this.router.createUrlTree([''], { queryParams: { ...route.queryParams, new_signup_navigation: true } });
            this.redirectService.redirectTo(url);
            return false;
          } else {
            return true;
          }
        }
        return true;
      }),
      filter((shouldNavigateToOldSignup) => shouldNavigateToOldSignup),
      concatMap(() => this.authService.isAuthenticatedAsync()),
      map(isAuthenticated => {
        if (route.queryParams['from_login'] === 'true') {
          this.authService.resetCredentials();
          return true;
        }

        if (isAuthenticated) {
          this.router.navigateByUrl(SIGNUP_PLATFORM_PATH);
          return false;
        }
        return true;
      }));
  }
}
